import React, { forwardRef } from "react";
import { Form as AntdMobileForm } from "antd-mobile";
import { useForm, useWatch } from "rc-field-form";
import { BaseFormProps } from "./Form.types";
import "./Form.scss";

const BaseForm = forwardRef<any, BaseFormProps>(
  (
    {
      children,
      className = "",
      testId,
      mode = "default",
      layout = "vertical",
      ...props
    },
    ref
  ) => {
    const formClass = [
      "base-form",
      `base-form--${mode}`,
      `base-form--${layout}`,
      className,
    ]
      .filter(Boolean)
      .join(" ");

    return (
      <AntdMobileForm
        ref={ref}
        className={formClass}
        mode={mode}
        layout={layout}
        data-testid={testId}
        {...props}
      >
        {children}
      </AntdMobileForm>
    );
  }
);

BaseForm.displayName = "BaseForm";

// 创建带有静态方法的 Form 组件
export const Form = Object.assign(BaseForm, {
  useForm,
  useWatch,
});

export default Form;
